import ReactDOM from "react-dom/client";
import { Carousel } from "react-responsive-carousel";

export function renderGooglePlacesMarker(
  map: google.maps.Map,
  googlePlaceResult: google.maps.places.PlaceResult,
  handleInfoWindowClick: (
    infoWindow: google.maps.InfoWindow,
    marker: google.maps.marker.AdvancedMarkerElement
  ) => void,
  onInfoWindowClose: () => void,
  handleCreatePlace: (infoWindow: google.maps.InfoWindow) => void,
  handlePhotoClick: (
    index: number,
    photo: google.maps.places.PlacePhoto
  ) => void
) {
  const newMarker = new window.google.maps.marker.AdvancedMarkerElement({
    position: {
      lat: googlePlaceResult.geometry?.location?.lat() ?? 0,
      lng: googlePlaceResult.geometry?.location?.lng() ?? 0,
    },
    map,
    title: googlePlaceResult.name,
  });

  const photos = googlePlaceResult.photos || [];

  const handleInfoWindowDomReady = () => {
    const carouselContainer = document.getElementById(
      "google-place-photos-carousel"
    );
    if (carouselContainer && photos.length > 0) {
      const root = ReactDOM.createRoot(carouselContainer);
      root.render(
        <Carousel showThumbs={false} showStatus={false} autoPlay infiniteLoop>
          {photos.map((photo, index) => (
            <div
              key={index}
              onClick={() => {
                handlePhotoClick(index, photo);
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                src={photo.getUrl({ maxWidth: 400, maxHeight: 300 })}
                alt={`Place view ${index + 1}`}
                style={{ maxHeight: "200px", objectFit: "cover" }}
              />
            </div>
          ))}
        </Carousel>
      );
    }

    const yesButton = document.getElementById("yes-button");
    const noButton = document.getElementById("no-button");

    if (yesButton) {
      yesButton.addEventListener("click", async () => {
        handleCreatePlace(newInfoWindow);
      });
    }

    if (noButton) {
      noButton.addEventListener("click", () => {
        newInfoWindow.close();
        onInfoWindowClose();
      });
    }
  };

  let photosContentHtml: string = "";
  if (photos.length > 0) {
    photosContentHtml = '<div id="google-place-photos-carousel"></div>';
  }

  const newInfoWindow = new window.google.maps.InfoWindow({
    headerDisabled: true,
    content: `
      <div class="survey-info-window">
        <div class="name">${googlePlaceResult.name}</div>
        ${photosContentHtml}
        <div class="survey">
          <div class="survey-question">
            Are there pool tables here?
          </div>
          <div class="survey-buttons">
            <button type="button" class="btn btn-primary" id="yes-button">
              Yes, there are pool tables
            </button>
            <button type="button" class="btn btn-outline-primary" id="no-button">
              No
            </button>
          </div>
          <div class="survey-info">
            By clicking "Yes", you are confirming that this place has pool tables. We'll
            go ahead and add ${googlePlaceResult.name} to the database, but a few other
            users will need to confirm this before it received a verified status.
          </div>
        </div>
      </div>`,
  });

  newMarker.addListener("gmp-click", (event: google.maps.MapMouseEvent) => {
    event.stop?.();
    handleInfoWindowClick(newInfoWindow, newMarker);
  });
  newMarker.element.style.filter = "brightness(1.25) hue-rotate(135deg)";

  newInfoWindow.addListener("domready", handleInfoWindowDomReady);

  return {
    marker: newMarker,
    infoWindow: newInfoWindow,
  };
}
